import { Cart, RecoveredCart, AddItemProps, transformCart, getNow } from '@pegasus/cart';
import { getCSRFToken } from 'src/client/helpers';
import { CENTRAL_API_PREFIX, CSRF_HEADER } from 'src/shared/constants';
import { createRestClient, assertStatusCode } from '../restClient';

const client = createRestClient(CENTRAL_API_PREFIX, '/phoenix/stockcart/cart');

export const fetchCart = (): Promise<Cart> => {
    return client
        .get('')
        .then(assertStatusCode([200, 204]))
        .then(response => {
            if (response.status === 204) {
                return {
                    items: [],
                    expiresIn: 0,
                    expiresAt: getNow(),
                    savings: 0,
                    total: 0,
                    shippingCosts: 0,
                };
            }

            if (response.status === 401) {
                // Should flip isGuest to true (i.e token expired)
            }

            return response.json().then(transformCart);
        });
};

export const addItemToCart = ({ quantity = 1, ...props }: AddItemProps) => {
    return client
        .post(
            '/items',
            undefined,
            { quantity, ...props },
            {
                [CSRF_HEADER]: getCSRFToken(),
            },
        )
        .then(assertStatusCode([200]))
        .then(response => response.json());
};

export const fetchRecoveredCart = (): Promise<RecoveredCart> => {
    // const client = createRestClient(API_PREFIX, false);

    return Promise.resolve({ items: [] });
    // TODO: Temporarily disable the api call for the incomplete api, till it's fixed
    // https://jira.zalando.net/browse/ZLPC-2760
    // return client
    //     .get('/recovered-cart')
    //     .then(assertStatusCode([200]))
    //     .then(response => response.json());
};

export const removeItem = ({ simpleSku }: { simpleSku: string }): Promise<void> => {
    return client
        .delete(
            `/items/${simpleSku}`,
            {},
            {
                [CSRF_HEADER]: getCSRFToken(),
            },
        )
        .then(assertStatusCode([204]))
        .then(_ => undefined);
};

export const extendCart = (): Promise<void> => {
    return client
        .put(
            ``,
            {},
            {},
            {
                [CSRF_HEADER]: getCSRFToken(),
            },
        )
        .then(assertStatusCode([204]))
        .then(_ => undefined);
};
